import React from 'react';

const LandingPage = () => {
  return (
    <div className='p-5 center-item'>
      <div>
        <ol start='1' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>General</span>
            </strong>
            <strong>
              <span>&nbsp;Terms and Conditions</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <span>By using this&nbsp;</span>
            <span>Platform</span>
            <span>, you confirm that you have read and understood&nbsp;</span>
            <span>its&nbsp;</span>
            <span>Terms and Conditions,&nbsp;</span>
          </li>
          <li>
            <span>
              The platform terms and conditions apply and are binding to the end
              user&nbsp;
            </span>
            <span>&nbsp;</span>
          </li>
          <li>
            <span>These Terms and Conditions may change.</span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='2' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Privacy and Security</span>
            </strong>
          </li>
        </ol>
        <ul>
          <li>
            <span>&nbsp;</span>
            <span style={{ color: 'black' }}>B</span>
            <span>
              y using this platform and its Service you unequivocally and
              voluntarily give consent to&nbsp;
            </span>
            <span>the Development Bank of Rwanda (</span>
            <span>BRD</span>
            <span>)</span>
            <span>&nbsp;to collect, process (including profiling),&nbsp;</span>
            <span>transfer and&nbsp;</span>
            <span>
              share with third parties your personal data at any time for the
              purpose of providing, improving or upgrading the Service or the
              platform upon which the Service is hosted
            </span>
            <span>
              . Your personal data might also be shared for the purpose of&nbsp;
            </span>
            <span>analysing or assessing your eligibility&nbsp;</span>
            <span>
              into the affordable housing scheme to Rwanda Housing Authority
              (RHA)
            </span>
            <span>
              . Personal information collected will not be kept longer
            </span>
            <span>&nbsp;</span>
            <span>than is needed to provide you with the Service.</span>
          </li>
          <li>
            <span>Y</span>
            <span>our personal information and data</span>
            <span>&nbsp;will only be used for the&nbsp;</span>
            <span>
              purposes of, and in accordance with, the consent you have
              provided.
            </span>
          </li>
          <li>
            <span>
              Providing inaccurate or false information when using this Service
            </span>
            <span>&nbsp;shall</span>
            <span>&nbsp;result in</span>
            <span>&nbsp;program ineligibility and/</span>
            <span>or criminal penalties.</span>
          </li>
          <li>
            <span>
              Cookies are pieces of information generated by a web server and
              stored in the user&rsquo;s computer, ready for future access.
              Cookies make use of user-specific information transmitted by the
              web server onto the user&rsquo;s computer so that the information
              might be available for later access by itself or other servers.
              The portal will not install authentication cookies or similar
              cookies on an End-User device which could identify the
              End-User&rsquo;s financial details without the End-User&rsquo;s
              express written permission. By using this service, you hereby give
              written consent to BRD to collect and install cookies were
              necessary.
            </span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='3' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Right to share personal information</span>
            </strong>
          </li>
        </ol>
        <ul>
          <li>
            <span>&nbsp;</span>
            <span style={{ color: 'black' }}>BRD will</span>
            <span>&nbsp;receive</span>
            <span>, transfer,&nbsp;</span>
            <span>and share your</span>
            <span>&nbsp;</span>
            <span>personal information with third parties&nbsp;</span>
            <span>
              including but not limited to RHA, the agency in charge of housing
              for the only purpose of &nbsp;application for the affordable
              housing scheme
            </span>
            <span>.&nbsp;</span>
          </li>
          <li>
            <span>&nbsp;</span>
            <span style={{ color: 'black' }}>
              For purpose of &nbsp;the services provided &nbsp;by Giriwawe
              platform, y
            </span>
            <span>our personal&nbsp;</span>
            <span>data</span>
            <span>&nbsp;may&nbsp;</span>
            <span>also&nbsp;</span>
            <span>be&nbsp;</span>
            <span>shared abroad.&nbsp;</span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='4' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Termination, Suspension and Limitation</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <span>
              Notwithstanding this undertaking, you acknowledge and accept that
              we are entitled to modify, suspend or discontinue the Service at
              any time and that we will not be responsible for any damage or
              loss that you may suffer if we choose to do so. We may also choose
              to restrict access to certain or all of the functionality or
              services offered by us.
            </span>
          </li>
          <li>
            <span>
              This platform shall be terminated, suspended, and limited as per
              BRD own discretion. The functionality or service offered might
              temporarily or permanently be changed. &nbsp;A notice of
              information shall be shared on the platform. BRD will not be
              responsible for any damage or loss occurred to your personal
              data.&nbsp;
            </span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='5' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>No Warranties or Representations</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <span>T</span>
            <span>
              he Service is provided on an &ldquo;as is&rdquo; and &ldquo;as
              available&rdquo; basis. &nbsp;
            </span>
            <span style={{ color: 'black' }}>BRD&nbsp;</span>
            <span>do</span>
            <span>es</span>
            <span>
              &nbsp;not warrant or represent that the Service will be
              error-free, or that the content provided on or via the Service is
              or will be accurate, suitable, complete, or fit for or compatible
              with any particular purpose.
            </span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='6' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Disclaimer and Limitation of Liability</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <span>Except for any statutory liability that&nbsp;</span>
            <span style={{ color: 'black' }}>BRD</span>
            <span>
              &nbsp;may have towards you, and which cannot be disclaimed or
              altered by agreement between you and&nbsp;
            </span>
            <span>the Bank</span>
            <span>
              , neither we, nor our affiliates, employees, officers, providers,
              or agents will be responsible or liable in any way for any damage
              or loss of whatsoever nature arising from the Service, your use of
              or reliance on the Service, or on any information provided on or
              via the Service. You acknowledge and understand that use of this
              Service is entirely at your own risk.
            </span>
          </li>
          <li>
            <span>BRD is not responsible for any&nbsp;</span>
            <span>delays</span>
            <span>
              &nbsp;that arises from using any links to backend systems that are
              managed by other Government of Rwanda departments and agencies
              that are not under the control of BRD.
            </span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='7' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Capacity to enter into Agreements</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <span>By using the Service, you&nbsp;</span>
            <span>certify&nbsp;</span>
            <span>
              (promise in a way that you can be held legally bound by that
              promise) that you have the legal
            </span>
            <span>&nbsp;</span>
            <span>
              capacity to enter into and be bound by contractual terms.
            </span>
          </li>
          <li>
            <span>&nbsp;</span>
            <span style={{ color: 'black' }}>Y</span>
            <span>
              ou must be at least 18 years old in order to make use of the
              Service.
            </span>
          </li>
          <li>
            <span>
              If you are unsure whether you have the legal capacity to enter
              into contracts, you must contact&nbsp;
            </span>
            <span>the bank (by which mean)</span>
            <span>, and&nbsp;</span>
            <span>BRD&nbsp;</span>
            <span>
              shall be able to provide you with this information before you
              continue using the Service.
            </span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='8' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>
                Breach / Failure to Comply with these Terms and Conditions
              </span>
            </strong>
          </li>
        </ol>
        <ol className='decimal_type'>
          <li>
            <span>
              If you are in breach of these Terms and Conditions, or if you use
              the Service in an unauthorised manner or interact with the Service
              in any unlawful or unauthorised manner,&nbsp;
            </span>
            <span>BRD&nbsp;</span>
            <span>
              will be entitled to terminate your access to the Service
              immediately without prior notice, and without prejudice to any
              other rights we may have in terms of these Terms and Conditions or
              at law.
            </span>
          </li>
          <li>
            <span>
              Should your access to the Service be terminated as described
              above, you expressly acknowledge that any obligations that exist
              between you and&nbsp;
            </span>
            <span>the bank</span>
            <span>
              &nbsp;at the time of such termination, as set out in a loan
              agreement or these terms and conditions of use, will continue to
              remain in place until such outstanding obligations have been met.
            </span>
          </li>
        </ol>
      </div>
      <div>
        <ol start='9' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Governing Law</span>
            </strong>
          </li>
        </ol>
        <ol className='decimal_type'>
          <li>
            <span>
              These Terms and Conditions are governed by and will be interpreted
              in accordance with the laws of the Republic of Rwanda without
              reference to any conflict of law provisions. All interactions and
              transactions made or conducted on this Service (including on or in
              relation to any loan provided) will be subject to the laws of the
              Republic of Rwanda.
            </span>
          </li>
          <li>
            <span>
              Any dispute relating to or arising out of these terms and any
              non-contractual obligations arising out of or in connection with
              them, shall be subject to the exclusive jurisdiction of the Rwanda
              Courts after a failure to resolve the dispute amicably through a
              grievance redress mechanism in accordance with BRD&rsquo;s
              grievance redress mechanism.
            </span>
          </li>
          <li>
            <span>
              Any mediation held with regard to these Terms and Conditions will
              be conducted behind closed doors where we and you will be required
              to treat all details of the dispute submitted to mediation, the
              conduct of the mediation proceedings and the outcome of the
              mediation as confidential.
            </span>
          </li>
        </ol>
      </div>
      <p>
        <br />
      </p>
    </div>
  );
};

export default LandingPage;
